// DashTable.tsx
import React, { useState } from "react";
import { Box, Paper, Table, TableBody, TableContainer } from "@mui/material";
import EnhancedTableHead from "./TableHead";
import TableLists from "./TableList";

interface ProcedureData {
  id: number;
  procedureTitle: string;
  price: number;
  gst: number;
  branchId: string;
}

const DashTable = ({
  setShow,
  setUpdateData,
  setView,
  list,
  deleted,
  setDeleted,
  refetch,
}) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof ProcedureData>("id");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof ProcedureData
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <div className="Enhance-table">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer className="custom-tablebody">
            <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                <TableLists
                  order={order}
                  list={list}
                  setShow={setShow}
                  deleted={deleted}
                  setDeleted={setDeleted}
                  setUpdateData={setUpdateData}
                  setView={setView}
                  refetch={refetch}
                />
              </TableBody>
            </Table>
            {(!list?.data || list?.data.length === 0) && (
              <div className="d-flex justify-content-center">
                No data available!
              </div>
            )}
          </TableContainer>
        </Paper>
      </Box>
    </div>
  );
};

export default DashTable;
